import { render, staticRenderFns } from "./addTeam.vue?vue&type=template&id=488c5803&scoped=true&"
import script from "./addTeam.vue?vue&type=script&lang=js&"
export * from "./addTeam.vue?vue&type=script&lang=js&"
import style0 from "./addTeam.vue?vue&type=style&index=0&id=488c5803&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488c5803",
  null
  
)

export default component.exports